import { render } from "./vrefundapplicationmerge.vue?vue&type=template&id=98b3e906&scoped=true"
import script from "./vrefundapplicationmerge.vue?vue&type=script&lang=js"
export * from "./vrefundapplicationmerge.vue?vue&type=script&lang=js"

import "./vrefundapplicationmerge.vue?vue&type=style&index=0&id=98b3e906&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98b3e906"]])

export default __exports__